import styled, { ColorLabel, IBackgroundColor } from "grabcad-ui-elements";
export enum HomePageColor {
    LABEL_NEUTRAL = "#858585",
}

export const HomePageLabel = styled(ColorLabel)<IBackgroundColor>`
    font-size: 14px;
`;
export const cardMargin = "10px";

export const HomePage = styled.div`
    height: 100%;
    align-items: center;
    animation: fadeIn 0.5s linear;
    display: flex;
    flex-direction: column;
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    > div {
        width: 100%;
        min-width: 800px;
        max-width: 1080px;
        margin: auto;
    }
    h1 {
        font-size: 24px;
        color: #333333;
    }
    h2 {
        font-size: 18px;
    }
    .hero {
        > img {
            z-index: 100;
            float: right;
            position: relative;
            top: -4.5rem;
            right: 20px;
            margin-bottom: -8rem;
        }
        > div {
            padding: 2rem;
        }
    }
    p {
        margin: 10px 0;
        font-size: 16px;
        line-height: 125%;
    }
    .card {
        width: calc(100% - 2 * ${cardMargin});
        min-width: 250px;
        margin: ${cardMargin};
        color: rgba(0, 0, 0, 0.87);
        background: #fff;
        border: none;
        border-radius: 0.28571429rem;
        box-shadow: 0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5;
    }
    .linkCards {
        display: flex;
        width: 100%;
        .card {
            flex: 1 1 250px;
            padding: 20px;
            cursor: pointer;
            &:hover {
                box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
            }
            h2 {
                margin-top: 16px;
                margin-bottom: 16px;
            }
            .labelContainer {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 0.4rem 0.3rem;
            }
        }
    }
`;

export const HomePageOld = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    animation: fadeIn 0.5s linear;
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    > div {
        max-width: 800px;
        margin: auto;
    }
    h1 {
        font-size: 24px;
        color: #003393;
        margin: 1rem;
    }
    h2 {
        font-size: 18px;
        line-height: 125%;
    }
    .hero {
        display: flex;
        flex-direction: row;
        > a {
            display: block;
            flex: 0 0 calc(33.333% - 17px);
            border-right: 1px solid #d4d4d5;
            display: flex;
            align-items: center;
            justify-content: space-around;
        }
        > div {
            padding: 2rem;
        }
    }
    p {
        margin: 10px 0;
        font-size: 14px;
        line-height: 125%;
    }
    .card {
        width: calc(100% - 2rem);
        margin: 1rem;
        color: rgba(0, 0, 0, 0.87);
        background: #fff;
        border: none;
        border-radius: 0.28571429rem;
        box-shadow: 0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5;
    }
    .linkCards {
        display: flex;
        .card {
            width: 33.333%;
            padding: 1rem;
            cursor: pointer;
            &:hover {
                box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
            }
            h2 {
                text-align: center;
            }
            .imgHolder {
                height: 104px;
                display: flex;
                align-items: center;
                justify-content: space-around;
            }
        }
    }
`;
